// import { useEffect, useState } from "react";
// import Button from "../common/Button";
// import { getAllSubjects } from "../../services/subjectService";

// const SubjectForm = ({
//   onSubmit,
//   onCancel,
//   initial = {},
//   loading = false,
//   step,
// }) => {
//   // Accept both possible initial shapes: id or SubjectID
//   const [subjectId] = useState(
//     initial.id ?? initial.SubjectID ?? initial.subjectId ?? ""
//   );
//   const [name, setName] = useState(
//     initial.name || initial.subjectName || initial.SubjectName || ""
//   );
//   const [subjectCode, setSubjectCode] = useState(
//     initial.subjectCode || initial.SubjectCode || ""
//   );
//   const [description, setDescription] = useState(
//     initial.description || initial.Description || ""
//   );
//   const [descriptionError, setDescriptionError] = useState("");

//   const [formError, setFormError] = useState("");
//   const [checking, setChecking] = useState(false);
//   const [subjectCodeError, setSubjectCodeError] = useState("");
//   const [codeManuallyEdited, setCodeManuallyEdited] = useState(
//     Boolean(initial.subjectCode || initial.SubjectCode)
//   );
//   const [autoGeneratedCode, setAutoGeneratedCode] = useState("");

//   const generateSubjectCode = (subjectName = "") => {
//     const trimmed = subjectName.replace(/[^a-zA-Z]/g, "").toUpperCase();
//     const prefix = trimmed.slice(0, 3);
//     if (!prefix) return "";
//     const hash = Array.from(subjectName).reduce(
//       (acc, char, index) => acc + char.charCodeAt(0) * (index + 1),
//       0
//     );
//     const numericPart = String(hash % 1000).padStart(3, "0");
//     return `${prefix}${numericPart}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setFormError("");
//     setDescriptionError("");
//     setSubjectCodeError("");
//     const trimmedName = name.trim();
//     const trimmedCode = subjectCode.trim();
//     const trimmedDescription = description.trim();

//     // Validate both fields and show both errors at once if missing
//     let hasError = false;
//     if (!trimmedName) {
//       setFormError("Class name is required");
//       hasError = true;
//     }
//     if (!trimmedCode) {
//       setSubjectCodeError("Class code is required");
//       hasError = true;
//     }
//     // enforce format: uppercase alnum, dash or underscore, 2-20 chars
//     if (trimmedCode && !/^[A-Z0-9_-]{2,20}$/.test(trimmedCode)) {
//       setSubjectCodeError(
//         "Class code must be 2–20 alphanumeric characters (no spaces)"
//       );
//       hasError = true;
//     }
//     if (trimmedDescription.length > 500) {
//       setDescriptionError("Description must be 500 characters or less.");
//       hasError = true;
//     }
//     if (hasError) return;

//     // build payload including both common keys to improve backend compatibility
//     const payload = {
//       // include id when editing (cover multiple naming conventions)
//       ...(subjectId
//         ? {
//             id: subjectId,
//             SubjectID: subjectId,
//             subjectId: subjectId,
//           }
//         : {}),
//       name: trimmedName,
//       subjectName: trimmedName,
//       SubjectName: trimmedName,
//       subjectCode: trimmedCode,
//       SubjectCode: trimmedCode,
//       description: trimmedDescription,
//       Description: trimmedDescription,
//       // include courseName if provided initially so duplicate checks can scope to a course
//       ...(initial.courseName
//         ? {
//             courseName: initial.courseName,
//             CourseName: initial.courseName,
//           }
//         : {}),
//     };

//     // Prevent adding the same subject to the same course
//     setChecking(true);
//     try {
//       const subjects = await getAllSubjects();
//       const lowerName = trimmedName.toLowerCase();
//       const courseName = (initial.courseName || "")
//         .toString()
//         .trim()
//         .toLowerCase();

//       const lowerCode = trimmedCode.toLowerCase();
//       const duplicate = subjects.find((s) => {
//         const sName = (s.name || s.subjectName || "")
//           .toString()
//           .trim()
//           .toLowerCase();
//         const sCode = (s.code || s.subjectCode || "")
//           .toString()
//           .trim()
//           .toLowerCase();
//         const sCourse = (s.courseName || "").toString().trim().toLowerCase();
//         // consider duplicate if name or code matches within same course scope (if provided)
//         if (courseName) {
//           return (
//             (sName === lowerName && sCourse === courseName) ||
//             (sCode && sCode === lowerCode && sCourse === courseName)
//           );
//         }
//         return sName === lowerName || (sCode && sCode === lowerCode);
//       });

//       if (duplicate) {
//         // allow edit of the same record (same id)
//         const dupId =
//           duplicate.id ?? duplicate.SubjectID ?? duplicate.subjectId ?? "";
//         if (subjectId && String(dupId) === String(subjectId)) {
//           // it's the same record; allow
//         } else {
//           // prefer a code-specific message if codes match
//           const dupCode = (duplicate.code ?? duplicate.subjectCode ?? "")
//             .toString()
//             .trim()
//             .toLowerCase();
//           if (dupCode && dupCode === trimmedCode.toLowerCase()) {
//             setFormError(
//               courseName
//                 ? "A class with this code already exists for the selected course."
//                 : "A class with this code already exists."
//             );
//           } else {
//             setFormError(
//               courseName
//                 ? "This class already exists for the selected course."
//                 : "A class with this name already exists."
//             );
//           }
//           setChecking(false);
//           return;
//         }
//       }
//     } catch (err) {
//       // If subject list fetch fails, allow submission but warn in console
//       console.warn("Could not validate duplicates from backend:", err);
//     } finally {
//       setChecking(false);
//     }

//     onSubmit(payload);
//   };

//   useEffect(() => {
//     if (initial.subjectCode || initial.SubjectCode) {
//       setCodeManuallyEdited(true);
//       return;
//     }
//     if (codeManuallyEdited) return;
//     if (!name) {
//       if (autoGeneratedCode) {
//         setAutoGeneratedCode("");
//         setSubjectCode("");
//       }
//       return;
//     }

//     const generated = generateSubjectCode(name);
//     if (!generated || generated === autoGeneratedCode) return;
//     setAutoGeneratedCode(generated);
//     setSubjectCode(generated);
//   }, [
//     name,
//     codeManuallyEdited,
//     autoGeneratedCode,
//     initial.subjectCode,
//     initial.SubjectCode,
//   ]);

//   return (
//     <form onSubmit={handleSubmit} className="space-y-3">
//       {step ? (
//         <div className="text-sm font-medium text-indigo-600">
//           Step {step} of 2
//         </div>
//       ) : null}

//       <div>
//         <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
//           Class Code <span className="text-red-500">*</span>
//         </label>
//         <input
//           disabled
//           value={subjectCode}
//           onChange={(e) => {
//             // normalize to uppercase and clear code errors
//             const upper = String(e.target.value || "")
//               .toUpperCase()
//               .replace(/\s+/g, "");
//             setSubjectCode(upper);
//             setSubjectCodeError("");
//             setCodeManuallyEdited(true);
//           }}
//           placeholder="e.g. WAT818"
//           className="mt-1 block w-full rounded-md dark:bg-gray-700  border-gray-300 p-2"
//         />
//         {subjectCodeError ? (
//           <p className="mt-1 text-sm text-red-600">{subjectCodeError}</p>
//         ) : null}
//       </div>

//       <div>
//         <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
//           Class Name <span className="text-red-500">*</span>
//         </label>
//         <input
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           placeholder="e.g. Wattala Class-Mon"
//           className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
//         />
//         {formError ? (
//           <p className="mt-1 text-sm text-red-600">{formError}</p>
//         ) : null}
//       </div>

//       <div>
//         <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
//           Description
//         </label>
//         <textarea
//           value={description}
//           onChange={(e) => setDescription(e.target.value)}
//           className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
//           placeholder="Brief description (optional)"
//         />
//         {descriptionError ? (
//           <p className="mt-1 text-sm text-red-600">{descriptionError}</p>
//         ) : null}
//       </div>

//       <div className="flex flex-wrap justify-end gap-2">
//         <Button
//           type="button"
//           variant="secondary"
//           onClick={onCancel}
//           disabled={loading || checking}
//         >
//           Cancel
//         </Button>
//         <Button type="button" variant="primary" disabled={loading || checking} onClick={handleSubmit}>
//           {loading || checking ? "Saving..." : "Save"}
//         </Button>
//       </div>
//     </form>
//   );
// };

// export default SubjectForm;
import { useEffect, useState } from "react";
import Button from "../common/Button";
import { getAllSubjects } from "../../services/subjectService";

const SubjectForm = ({
  onSubmit,
  onCancel,
  initial = {},
  loading = false,
  step,
}) => {
  // Accept both possible initial shapes: id or SubjectID
  const [subjectId] = useState(
    initial.id ?? initial.SubjectID ?? initial.subjectId ?? ""
  );
  const [name, setName] = useState(
    initial.name || initial.subjectName || initial.SubjectName || ""
  );
  const [subjectCode, setSubjectCode] = useState(
    initial.subjectCode || initial.SubjectCode || ""
  );
  const [description, setDescription] = useState(
    initial.description || initial.Description || ""
  );
  const [fee, setFee] = useState(
    (() => {
      const v = initial.fee ?? initial.Fee ?? initial.subjectFee ?? initial.SubjectFee ?? "";
      if (v === null || v === undefined || v === "") return "";
      const s = String(v).replace(/,/g, "");
      const n = Number(s);
      if (Number.isNaN(n)) return String(v);
      return n % 1 === 0 ? n.toLocaleString() : n.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
    })()
  );
  const [duration, setDuration] = useState(
    initial.duration ?? initial.Duration ?? ""
  );
  const [monthlyFee, setMonthlyFee] = useState(
    (() => {
      const v = initial.monthlyFee ?? initial.MonthlyFee ?? initial.monthly ?? "";
      if (v === null || v === undefined || v === "") return "";
      const s = String(v).replace(/,/g, "");
      const n = Number(s);
      if (Number.isNaN(n)) return String(v);
      return n % 1 === 0 ? n.toLocaleString() : n.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
    })()
  );
  const [monthlyFeeManuallyEdited, setMonthlyFeeManuallyEdited] = useState(
    Boolean(
      initial.monthlyFee ?? initial.MonthlyFee ?? initial.monthly ?? false
    )
  );
  const [feeError, setFeeError] = useState("");
  const [durationError, setDurationError] = useState("");
  const [monthlyFeeError, setMonthlyFeeError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");

  const [formError, setFormError] = useState("");
  const [checking, setChecking] = useState(false);
  const [subjectCodeError, setSubjectCodeError] = useState("");
  const [codeManuallyEdited, setCodeManuallyEdited] = useState(
    Boolean(initial.subjectCode || initial.SubjectCode)
  );
  const [autoGeneratedCode, setAutoGeneratedCode] = useState("");

  const generateSubjectCode = (subjectName = "") => {
    const trimmed = subjectName.replace(/[^a-zA-Z]/g, "").toUpperCase();
    const prefix = trimmed.slice(0, 3);
    if (!prefix) return "";
    const hash = Array.from(subjectName).reduce(
      (acc, char, index) => acc + char.charCodeAt(0) * (index + 1),
      0
    );
    const numericPart = String(hash % 1000).padStart(3, "0");
    return `${prefix}${numericPart}`;
  };

  // helper: format numeric string with thousand separators, preserve up to 2 decimals
  const formatWithCommas = (value) => {
    if (value === null || value === undefined) return "";
    const s = String(value).trim();
    if (s === "") return "";
    const raw = s.replace(/,/g, "");
    // allow leading minus? fees should be non-negative so ignore minus
    const parts = raw.split(".");
    const intPart = parts[0].replace(/[^0-9]/g, "") || "0";
    const fracPart = parts[1] ? parts[1].replace(/[^0-9]/g, "").slice(0, 2) : "";
    const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fracPart ? `${intFormatted}.${fracPart}` : intFormatted;
  };

  const parseNumber = (formatted) => {
    if (formatted === null || formatted === undefined) return NaN;
    const raw = String(formatted).replace(/,/g, "").trim();
    if (raw === "") return NaN;
    return Number(raw);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    setDescriptionError("");
    setSubjectCodeError("");
    setFeeError("");
    setDurationError("");
    setMonthlyFeeError("");
    const trimmedName = name.trim();
    const trimmedCode = subjectCode.trim();
    const trimmedDescription = description.trim();

    // Validate both fields and show both errors at once if missing
    let hasError = false;
    if (!trimmedName) {
      setFormError("Class name is required");
      hasError = true;
    }
    if (!trimmedCode) {
      setSubjectCodeError("Class code is required");
      hasError = true;
    }
    // enforce format: uppercase alnum, dash or underscore, 2-20 chars
    if (trimmedCode && !/^[A-Z0-9_-]{2,20}$/.test(trimmedCode)) {
      setSubjectCodeError(
        "Class code must be 2–20 alphanumeric characters (no spaces)"
      );
      hasError = true;
    }
    if (trimmedDescription.length > 500) {
      setDescriptionError("Description must be 500 characters or less.");
      hasError = true;
    }

    // Validate numeric fields if provided
    const parsedFee = String(fee).toString().trim().replace(/,/g, "");
    if (parsedFee) {
      const num = Number(parsedFee);
      if (Number.isNaN(num) || num < 0) {
        setFeeError("Subject fee must be a non-negative number.");
        hasError = true;
      }
    }

    const parsedMonthly = String(monthlyFee).toString().trim().replace(/,/g, "");
    if (parsedMonthly) {
      const num = Number(parsedMonthly);
      if (Number.isNaN(num) || num < 0) {
        setMonthlyFeeError("Monthly fee must be a non-negative number.");
        hasError = true;
      }
    }

    const parsedDuration = String(duration).toString().trim();
    if (parsedDuration) {
      // allow numbers or short text like "3 months"; if numeric, ensure positive
      const asNum = Number(parsedDuration);
      if (!Number.isNaN(asNum) && asNum <= 0) {
        setDurationError("Duration must be greater than zero.");
        hasError = true;
      }
    }
    if (hasError) return;

    // build payload including both common keys to improve backend compatibility
    const payload = {
      // include id when editing (cover multiple naming conventions)
      ...(subjectId
        ? {
            id: subjectId,
            SubjectID: subjectId,
            subjectId: subjectId,
          }
        : {}),
      name: trimmedName,
      subjectName: trimmedName,
      SubjectName: trimmedName,
      subjectCode: trimmedCode,
      SubjectCode: trimmedCode,
      description: trimmedDescription,
      Description: trimmedDescription,
      // optional financial/duration fields
      ...(String(fee || "").trim()
        ? {
            fee: Number(String(fee).trim().replace(/,/g, "")),
            Fee: Number(String(fee).trim().replace(/,/g, "")),
            subjectFee: Number(String(fee).trim().replace(/,/g, "")),
            SubjectFee: Number(String(fee).trim().replace(/,/g, "")),
          }
        : {}),
      ...(String(monthlyFee || "").trim()
        ? {
            monthlyFee: Number(String(monthlyFee).trim().replace(/,/g, "")),
            MonthlyFee: Number(String(monthlyFee).trim().replace(/,/g, "")),
          }
        : {}),
      ...(String(duration || "").trim()
        ? {
            duration: String(duration).trim(),
            Duration: String(duration).trim(),
          }
        : {}),
      // include courseName if provided initially so duplicate checks can scope to a course
      ...(initial.courseName
        ? {
            courseName: initial.courseName,
            CourseName: initial.courseName,
          }
        : {}),
    };

    // Prevent adding the same subject to the same course
    setChecking(true);
    try {
      const subjects = await getAllSubjects();
      const lowerName = trimmedName.toLowerCase();
      const courseName = (initial.courseName || "")
        .toString()
        .trim()
        .toLowerCase();

      const lowerCode = trimmedCode.toLowerCase();
      const duplicate = subjects.find((s) => {
        const sName = (s.name || s.subjectName || "")
          .toString()
          .trim()
          .toLowerCase();
        const sCode = (s.code || s.subjectCode || "")
          .toString()
          .trim()
          .toLowerCase();
        const sCourse = (s.courseName || "").toString().trim().toLowerCase();
        // consider duplicate if name or code matches within same course scope (if provided)
        if (courseName) {
          return (
            (sName === lowerName && sCourse === courseName) ||
            (sCode && sCode === lowerCode && sCourse === courseName)
          );
        }
        return sName === lowerName || (sCode && sCode === lowerCode);
      });

      if (duplicate) {
        // allow edit of the same record (same id)
        const dupId =
          duplicate.id ?? duplicate.SubjectID ?? duplicate.subjectId ?? "";
        if (subjectId && String(dupId) === String(subjectId)) {
          // it's the same record; allow
        } else {
          // prefer a code-specific message if codes match
          const dupCode = (duplicate.code ?? duplicate.subjectCode ?? "")
            .toString()
            .trim()
            .toLowerCase();
          if (dupCode && dupCode === trimmedCode.toLowerCase()) {
            setFormError(
              courseName
                ? "A class with this code already exists for the selected course."
                : "A class with this code already exists."
            );
          } else {
            setFormError(
              courseName
                ? "This class already exists for the selected course."
                : "A class with this name already exists."
            );
          }
          setChecking(false);
          return;
        }
      }
    } catch (err) {
      // If subject list fetch fails, allow submission but warn in console
      console.warn("Could not validate duplicates from backend:", err);
    } finally {
      setChecking(false);
    }

    onSubmit(payload);
  };

  useEffect(() => {
    if (initial.subjectCode || initial.SubjectCode) {
      setCodeManuallyEdited(true);
      return;
    }
    if (codeManuallyEdited) return;
    if (!name) {
      if (autoGeneratedCode) {
        setAutoGeneratedCode("");
        setSubjectCode("");
      }
      return;
    }

    const generated = generateSubjectCode(name);
    if (!generated || generated === autoGeneratedCode) return;
    setAutoGeneratedCode(generated);
    setSubjectCode(generated);
  }, [
    name,
    codeManuallyEdited,
    autoGeneratedCode,
    initial.subjectCode,
    initial.SubjectCode,
  ]);

  // Auto-calculate monthlyFee = fee / duration when possible
  useEffect(() => {
    if (monthlyFeeManuallyEdited) return;

    // parse fee as number (allow formatted input like "2,000")
    const feeRaw = String(fee ?? "").trim().replace(/,/g, "");
    const feeNum = Number(feeRaw);
    if (Number.isNaN(feeNum) || feeNum === 0) return;

    // extract first numeric value from duration (e.g. "3 months" -> 3)
    const durRaw = String(duration ?? "").trim();
    if (!durRaw) return;
    const match = durRaw.match(/-?\d+(?:\.\d+)?/);
    const durNum = match ? Number(match[0]) : Number(durRaw);
    if (Number.isNaN(durNum) || durNum <= 0) return;

    const monthly = feeNum / durNum;
    const rounded = Math.round(monthly * 100) / 100; // two decimals
    const display = Number.isInteger(rounded)
      ? String(rounded)
      : rounded.toFixed(2);
    // format auto-calculated monthly fee with thousand separators
    setMonthlyFee(formatWithCommas(display));
  }, [fee, duration, monthlyFeeManuallyEdited]);

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      {step ? (
        <div className="text-sm font-medium text-indigo-600">
          Step {step} of 2
        </div>
      ) : null}

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Class Code <span className="text-red-500">*</span>
        </label>
        <input
          disabled
          value={subjectCode}
          onChange={(e) => {
            // normalize to uppercase and clear code errors
            const upper = String(e.target.value || "")
              .toUpperCase()
              .replace(/\s+/g, "");
            setSubjectCode(upper);
            setSubjectCodeError("");
            setCodeManuallyEdited(true);
          }}
          placeholder="e.g. WAT818"
          className="mt-1 block w-full rounded-md dark:bg-gray-700  border-gray-300 p-2"
        />
        {subjectCodeError ? (
          <p className="mt-1 text-sm text-red-600">{subjectCodeError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Class Name <span className="text-red-500">*</span>
        </label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Wattala Class-Mon"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {formError ? (
          <p className="mt-1 text-sm text-red-600">{formError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Description
        </label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
          placeholder="Brief description (optional)"
        />
        {descriptionError ? (
          <p className="mt-1 text-sm text-red-600">{descriptionError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Subject Fee
        </label>
        <input
          value={fee}
          onChange={(e) => {
            const raw = String(e.target.value || "").replace(/,/g, "");
            // keep only digits and optional decimal
            const sanitized = raw.replace(/[^0-9.]/g, "");
            // ensure single decimal point
            const parts = sanitized.split(".");
            const intPart = parts[0] || "";
            const frac = parts[1] ? parts[1].slice(0, 2) : "";
            const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const formatted = frac ? `${formattedInt}.${frac}` : formattedInt;
            setFee(formatted);
            setFeeError("");
          }}
          placeholder="e.g. 2,000"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {feeError ? (
          <p className="mt-1 text-sm text-red-600">{feeError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Duration(Months)
        </label>
        <input
          value={duration}
          onChange={(e) => {
            setDuration(e.target.value);
            setDurationError("");
          }}
          placeholder="e.g. 3 months or 12"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {durationError ? (
          <p className="mt-1 text-sm text-red-600">{durationError}</p>
        ) : null}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Monthly Fee
        </label>
        <input
          value={monthlyFee}
          onChange={(e) => {
            const raw = String(e.target.value || "").replace(/,/g, "");
            const sanitized = raw.replace(/[^0-9.]/g, "");
            const parts = sanitized.split(".");
            const intPart = parts[0] || "";
            const frac = parts[1] ? parts[1].slice(0, 2) : "";
            const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const formatted = frac ? `${formattedInt}.${frac}` : formattedInt;
            setMonthlyFee(formatted);
            setMonthlyFeeManuallyEdited(true);
            setMonthlyFeeError("");
          }}
          placeholder="e.g. 250"
          className="mt-1 block w-full rounded-md dark:bg-gray-700 border-gray-300 p-2"
        />
        {monthlyFeeError ? (
          <p className="mt-1 text-sm text-red-600">{monthlyFeeError}</p>
        ) : null}
      </div>

      <div className="flex flex-wrap justify-end gap-2">
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          disabled={loading || checking}
        >
          Cancel
        </Button>
        <Button type="button" variant="primary" disabled={loading || checking} onClick={handleSubmit}>
          {loading || checking ? "Saving..." : "Save"}
        </Button>
      </div>
    </form>
  );
};

export default SubjectForm;
